
let React = require("react");

let Button = require("./Button.jsx")
class ActionButton extends React.Component  {
    constructor(){
        super()

        this.onClick = this.onClick.bind(this);
    }

    onClick(){
        if(this.props.action){
            let {handleError, resource, setConfirmation, setLoading, setError, type} = this.props;

            this.props.action(handleError, resource, setConfirmation, setLoading, setError, type)
        }
    }

    render(){
        const {
            tooltip = '',
            disabled,
            addedClass = "",
            mainClass = "button",
            removeDisable,
            reasonDisabled,
            tooltipPos=""
        } = this.props;

        return <Button className={`${mainClass} ${addedClass}`} 
                    tooltip={tooltip} 
                    tooltipPos={tooltipPos}
                    disabled={disabled} 
                    onClick={this.onClick}
                    removeDisable={removeDisable} 
                    reasonDisabled={reasonDisabled}>
                        {this.props.text}
               </Button>
    }
}

module.exports = ActionButton;